import { InternalNavigationLink } from '../../../components';
import envReader from '../../../config/envReader';

export const ServiceGeneralPage = () => (
  <div>
    <InternalNavigationLink
      href={`${envReader.VITE_PUBLIC_URL}/data-act/general/${'Data Access Terms and Conditions for Users EN 2025 08 25.pdf'}`}
      text='English'
    />
  </div>
);
